/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class SimpleModeTipStrService {
    i18n = {
        switchTitle: this.get('home.SimplifiedModeSwtich_title'),
        switchContent: this.get('home.SimplifiedModeSwtich_info'),
        assistantTitle: this.get('home.smartAssistant_title'),
        assistantContent: this.get('home.smartAssistant_info'),
        experienceNow: this.get('home.smartAssistant_experienceNow_btn'),
        nextBtn: this.get('common.next_button'),
        finishBtn: this.get('home.SimplifiedModeSwtich_confirm'),
        notShowAgain: this.get('home.smartAssistant_notShow_btn'),
    };

    constructor(private i18nService: I18nService) { }

    get(key: string): string {
        return this.i18nService.get(key);
    }
}
